// extracted by mini-css-extract-plugin
var _1 = "VersionChanges-module__active--MZInf";
var _2 = "VersionChanges-module__animateUploadProgressBarWidth--q5hMZ";
var _3 = "VersionChanges-module__animatedBackground--qd61r";
var _4 = "VersionChanges-module__bar--Rvef9";
var _5 = "VersionChanges-module__barButton--xcl1H";
var _6 = "VersionChanges-module__barContainer--IQMmg";
var _7 = "VersionChanges-module__barContent--Q0g62";
var _8 = "VersionChanges-module__checkIcon--YWaDJ";
var _9 = "VersionChanges-module__checkIconContainer--oi0e9";
var _a = "VersionChanges-module__checked--FHpdi";
var _b = "VersionChanges-module__cyclingButtons--sOatL";
var _c = "VersionChanges-module__cyclingContainer--ScIg9";
var _d = "VersionChanges-module__cyclingLabel--IaC82";
var _e = "VersionChanges-module__editorContainer--GMXdu";
var _f = "VersionChanges-module__editorRoot--MGX0C";
var _10 = "VersionChanges-module__historicalPost--T6_Dy";
var _11 = "VersionChanges-module__modeSelectOption--oSt10";
var _12 = "VersionChanges-module__muted--z5Wi0";
var _13 = "VersionChanges-module__selectButton--at2Jw";
var _14 = "VersionChanges-module__selectButtonCaret--AjT5Q";
var _15 = "VersionChanges-module__selectButtonContent--q98oA";
var _16 = "VersionChanges-module__selectButtonText--fK5Ga";
var _17 = "VersionChanges-module__versionMeta--t3Fds";
export { _1 as "active", _2 as "animateUploadProgressBarWidth", _3 as "animatedBackground", _4 as "bar", _5 as "barButton", _6 as "barContainer", _7 as "barContent", _8 as "checkIcon", _9 as "checkIconContainer", _a as "checked", _b as "cyclingButtons", _c as "cyclingContainer", _d as "cyclingLabel", _e as "editorContainer", _f as "editorRoot", _10 as "historicalPost", _11 as "modeSelectOption", _12 as "muted", _13 as "selectButton", _14 as "selectButtonCaret", _15 as "selectButtonContent", _16 as "selectButtonText", _17 as "versionMeta" }
